import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import styled from "styled-components";
import { WMKLink } from "wmk-lib";
import Theme from "../../../vars/ThemeOptions";
import get from "lodash/get";
import LPIconTextLink from "./LPIconTextLink";
import ContentfulImg from "../../common/ContentfulImg";

const Styled = {};
Styled.IconTextCopy = styled(Col)``;

Styled.IconText = styled(Container)`
  margin: auto;
  &.sideXside {
    padding: 3vh 2vh;
    .icon-copy {
      em {
        font-style: normal;
      }
      align-items: center;
      display: flex;
    }
  }
  &.icon {
    width: ${100 / 3}%;
    @media screen and (max-width: ${Theme.break.sm}) {
      width: 100%;
    }
    margin: 0;
    float: left;
    padding: 6%;
    .row div:first-child {
      order: 2;
    }
    .row div:last-child {
      order: 1;
    }
    .icon-copy {
      em {
        font-style: normal;
      }
    }
    .col {
      display: flex;
      justify-content: center;
      align-items: center;
      -webkit-flex: initial;
      span {
        font-weight: 400;
        font-family: "Rajdhani", sans-serif;
        text-align: center;
        padding-bottom: 0.5rem;
        height: 5rem;
      }
      .icon-copy {
        em {
          font-style: normal;
        }
      }
    }
  }
  &.callout {
    position: relative;
    max-width: none !important;
    width: 100%;
    @media screen and (max-width: 950px) {
      margin-top: 200px;
    }
    .icon-img {
      display: flex;
      -webkit-flex: initial;
      justify-content: center;
      align-items: center;
      z-index: 2;
      position: relative;
      left: 30%;
      @media screen and (max-width: 950px) {
        left: 0;
        //margin-top: 200px;;
      }
    }
    .icon-copy {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      display: flex;
      -webkit-flex: initial;
      z-index: 3;
      align-items: center;
      justify-content: center;
      text-align: right;
      font-size: 1.75rem;
      font-weight: 700;
      a {
        color: #707070;
      }
      @media screen and (max-width: 1300px) {
        left: -5%;
      }
      @media screen and (max-width: 950px) {
        //left: 5%;
        top: -100%;
        font-size: 1.25rem;
        //font-family: "Rajdhani", sans-serif;
        //text-shadow: 2px 2px 0px rgba(255, 255, 255, 0.85);
      }
      @media screen and (max-width: ${Theme.break.sm}) {
        //left: -15%;
      }
      em {
        font-style: normal;
        text-decoration: underline;
      }
      strong {
        font-weight: 900;
        font-size: 2rem;
      }
    }

    .bg {
      position: absolute;
      top: 20%;
      left: 0;
      height: 60%;
      width: 100%;
      background: rgb(254, 225, 71);
      background: linear-gradient(
        90deg,
        rgba(254, 225, 71, 1) 0%,
        rgba(238, 161, 23, 1) 100%
      );
      z-index: 1;
    }
  }
`;

const LPIconText = ({ block }) => {
  // console.log('block: ', block);
  const { sortOrder, text, title, iconImg, icon } = block;
  //console.log(iconImg, icon);
  const style =
    sortOrder < 3 ? "sideXside" : sortOrder === 3 ? "callout" : "icon";
  const isLinked = title.indexOf("Creative") > -1 || title.indexOf("Feed") > -1;
  // console.log('title.indexOf(":"): ', title.indexOf(":"));
  return (
    <Styled.IconText className={style} style={{ maxWidth: "860px" }}>
      <Row
        className={style === "icon" ? "flex-column" : undefined}
        style={{ overflow: "hidden" }}
      >
        <Col
          xs={style === "sideXside" ? 4 : undefined}
          //xs={12}
          className="icon-img"
          style={{ textAlign: "center" }}
        >
          {isLinked ? (
            <LPIconTextLink
              url={
                title.indexOf("BLM") > -1
                  ? "https://creativestrategiesforchange.com/"
                  : "https://www.gofundme.com/f/feed-denver039s-frontline-workers"
              }
            >
              <ContentfulImg
                img={get(icon, "file.contentType") ? icon : iconImg}
              />
            </LPIconTextLink>
          ) : (
            <ContentfulImg
              img={
                get(icon, "title").indexOf("[Gaiter Icon]") === 0
                  ? iconImg
                  : icon
              }
            />
          )}
        </Col>
        <Col className="icon-copy">
          <span>
            {title && style === "callout" && (
              <>
                <span>
                  <strong>
                    {title.indexOf(':') > -1 
                      ? title.slice(title.indexOf(':') + 1, title.length)
                      : title.slice(8, title.length)
                    }
                  </strong>
                  <em>
                    {style === "callout" ? (
                      <WMKLink
                        to={
                          "https://www.gofundme.com/f/exkkmp-stopasianhate?utm_medium=email&utm_source=product&utm_campaign=p_email%2B3201-24hr-reminder-v5"
                        }
                        target={"_self"}
                      >
                        {" or more,"}
                      </WMKLink>
                    ) : (
                      <> or more,</>
                    )}
                  </em>
                </span>
                <br />
              </>
            )}

            {text && text.copy && (
              <em>
                {style === "callout" ? (
                  <WMKLink
                    to={
                      "https://www.gofundme.com/f/exkkmp-stopasianhate?utm_medium=email&utm_source=product&utm_campaign=p_email%2B3201-24hr-reminder-v5"
                    }
                    target={"_self"}
                  >
                    {style === "callout"
                      ? text.copy.slice(9, text.copy.length)
                      : text.copy}
                  </WMKLink>
                ) : (
                  <>
                    {style === "callout"
                      ? text.copy.slice(9, text.copy.length)
                      : text.copy}
                  </>
                )}
              </em>
            )}
          </span>
        </Col>
        {style === "callout" && <div className="bg" />}
      </Row>
    </Styled.IconText>
  );
};

export default LPIconText;
